module.exports = __webpack_public_path__ + "static/halloween-2016-4a06e0e2d93fa1a9830693066af6a70b.png";